import { render, staticRenderFns } from "./ycmd-provider.vue?vue&type=template&id=bd56d9f2"
import script from "./ycmd-provider.vue?vue&type=script&lang=js"
export * from "./ycmd-provider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports